const SidebarToggleIcon = ({ hide, adminColor }) => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_351_3111)">
      <rect x="20" y="16" width="30" height="30" rx="15" fill="white" />
      <path
        d={
          hide
            ? "M32.4998 23.5L30.7373 25.2625L36.4623 31L30.7373 36.7375L32.4998 38.5L39.9998 31L32.4998 23.5Z"
            : "M37.5 23.5L39.2625 25.2625L33.5375 31L39.2625 36.7375L37.5 38.5L30 31L37.5 23.5Z"
        }
        fill={adminColor}
      />
    </g>

    <defs>
      <filter
        id="filter0_d_351_3111"
        x="0"
        y="0"
        width="70"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_351_3111"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_351_3111"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SidebarToggleIcon;
